import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import {
  resetBreadcrumbs,
  trimBreadcrumbs,
} from "../store/slices/navigationSlice";

export default function Breadcrumbs() {
  const dispatch = useDispatch();
  const breadcrumbs = useSelector((state) => state.navigation.breadcrumbs);

  if (!Array.isArray(breadcrumbs) || breadcrumbs.length <= 1) return null;

  return (
    <div className="w-full overflow-x-auto">
      <Breadcrumb>
        {breadcrumbs.map((crumb, idx) => {
          const isLast = idx === breadcrumbs.length - 1;
          const label = crumb?.label || crumb?.id || crumb?.path || "—";
          if (isLast) {
            return <Breadcrumb.Item key={crumb.path}>{label}</Breadcrumb.Item>;
          }
          return (
            <Breadcrumb.Item key={crumb.path}>
              <Link
                type="text"
                to={crumb.path}
                onClick={() => {
                  if (crumb.path === "/") {
                    dispatch(resetBreadcrumbs());
                  } else {
                    dispatch(trimBreadcrumbs(crumb.path));
                  }
                }}
              >
                {label}
              </Link>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
}
